<script setup lang="ts">
const { t } = useI18n()

const route = useRoute()

const introButtonConfig = computed(() => {
    return {
        type: 'internal',
        buttonType: 'secondary',
        active: true,
        large: true,
        center: true,
        link: 'form',
        query: 'restart',
        tracking: [
            { track: 'click' },
            { 'track-position': 1 },
            { 'track-name': t('confirmation.intro.cta') },
            { 'track-url': route.fullPath }
        ]
    }
})

const sectionTrackingAttributes = computed(() => {
    return [
        { track: 'view' },
        { 'track-position': 1 },
        { section: 'confirmation-intro', },
        { 'track-name': t('confirmation.intro.headline') },
        { 'track-url': route.fullPath }
    ]
})

const sectionTracking = computed(() => {
    if (!sectionTrackingAttributes.value) return {}

    const attributes = {}

    sectionTrackingAttributes.value.forEach((obj) => {
        for (const [key, value] of Object.entries(obj)) {
            attributes[`data-${key}`] = value
        }
    })
    return attributes
})
</script>

<template>
    <section class="confirmation-intro" v-bind="sectionTracking">
        <Subline :subline-config="{ title: t('confirmation.intro.subline1') }" />
        <MainHeadline :main-headline-config="{ title: t('confirmation.intro.headline') }" />

        <div class="divider" />

        <div class="confirmation-intro-text">
            <Subline :subline-config="{ title: t('confirmation.intro.subline2') }" />

            <p v-html="t('confirmation.intro.copy')" />
        </div>

        <Subline :subline-config=" { title: t('confirmation.intro.subline3') }" />

        <BaseButton :base-button-config="introButtonConfig">
            {{ t('confirmation.intro.cta') }}
        </BaseButton>
    </section>
</template>

<style lang="scss">
.confirmation-intro {
    text-align: center;
    grid-column: 2 / -2;
    @include section-padding($first: true);
}

.confirmation-intro-text {
    p {
        @include copytext;
    }

    &::before {
        content: '';
        width: 2px;
        background: $confirmation-intro-text-divider;
        margin: 0 auto px2rem(40);
        height: 40px;
        display: block;

        @include bp(medium1) {
            margin: 0 auto px2rem(60);
            height: 60px;
        }

        @include bp(large1) {
            margin: 0 auto px2rem(80);
            height: 80px;
        }

        @include bp(large2) {
            margin: 0 auto px2rem(100);
            height: 100px;
        }
    }
}
</style>
